import { exportModules } from '@/assets/js/__utils__/file';

// console.log('interceptors')
let requireFiles = require.context('@/config/interceptors', false, /\.js$/);
// console.log(requireFiles)
const modules = exportModules(requireFiles, true, true)

export default modules;
